import {
  Config,
  ChildProgressObservationReport,
  ChildProgressReportSummaryModel,
} from '@ecdlink/core';
import {
  ChildProgressReport,
  ChildProgressReportInput,
} from '@ecdlink/graphql';
import { api } from '../axios.helper';
import { inputObjectToCamelCase } from '@/utils/object-utils';

class ContentReportService {
  _accessToken: string;
  _locale: string;

  constructor(accessToken: string, locale: string) {
    this._accessToken = accessToken;
    this._locale = locale;
  }

  async syncChildProgressReport(
    input: ChildProgressReportInput
  ): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateChildProgressReport',
      variables: {
        input: inputObjectToCamelCase(input),
        id: input.Id,
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'Updating child progress report failed - Server connection error'
      );
    }

    return true;
  }

  async updateChildProgressReport(
    input: ChildProgressReportInput,
    id: string
  ): Promise<ChildProgressReport> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateChildProgressReport',
      variables: {
        input: inputObjectToCamelCase(input),
        id: id,
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'Updating child progress report failed - Server connection error'
      );
    }

    return response.data.data.updateChildProgressReport;
  }

  async generateChildProgressReport(
    childId: string,
    classgroupId: string,
    reportDate: Date
  ): Promise<string> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: `generateChildProgressReport`,
      variables: {
        childId: childId,
        classgroupId: classgroupId,
        reportDate: reportDate,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating child failed - Server connection error');
    }

    return response.data.data.generateChildProgressReport;
  }

  async getChildProgressReportsSummary(
    count: number = 5
  ): Promise<ChildProgressReportSummaryModel[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: `childProgressReportSummary`,
      variables: {
        count: count,
      },
    });
    if (response.status !== 200) {
      throw new Error(
        'Get child progress report summary failed - Server connection error'
      );
    }
    return response.data.data.childProgressReportSummary;
  }

  async getDetailedProgressReports(
    count: number = 5
  ): Promise<ChildProgressObservationReport[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: `childProgressReports`,
      variables: {
        count: count,
      },
    });
    if (response.status !== 200) {
      throw new Error(
        'Get child progress reports failed - Server connection error'
      );
    }
    return response.data.data.childProgressReports;
  }

  async getDetailedProgressReport(
    reportId: string
  ): Promise<ChildProgressObservationReport> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: `childProgressReport`,
      variables: {
        reportId: reportId,
      },
    });
    if (response.status !== 200) {
      throw new Error('Get progress report failed - Server connection error');
    }
    return response.data.data.childProgressReport;
  }
}

export default ContentReportService;
